import React from 'react';
import GeneralData from '../../GeneralData';
import ContactChart from '../../ContactChart';
import ConversionChart from '../../ConversionChart';
import { ChartsBelowSection } from './styles';

const Performance = ({
  leadsData,
  leadsChartData,
  chartType,
  setChartType,
  headerFilter,
  startFilter,
  endFilter,
  device,
  leadsError,
  leadsChartsError,
  reloadDispatch
}) => {
  return (
    <>
      <GeneralData
        data={leadsData}
        dataCharts={leadsChartData}
        chartType={chartType}
        setChartType={setChartType}
        device={device}
        filter={headerFilter}
        startFilter={startFilter}
        endFilter={endFilter}
        leadsChartsError={leadsChartsError}
        reloadDispatch={reloadDispatch}
      />
      <ChartsBelowSection device={device}>
        <ConversionChart device={device} data={leadsData} error={leadsError} reloadDispatch={reloadDispatch} />
        <ContactChart device={device} data={leadsData} error={leadsError} reloadDispatch={reloadDispatch} />
      </ChartsBelowSection>
    </>
  );
};

export default Performance;
